// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadingDialog {
  width: 350px;
}
.loadingDialog .alert {
  font-family: monospace;
  font-size: 0.75em;
  background: #cecece;
  color: #575757;
  border-radius: 8px;
  padding: 14px 18px;
  margin: 10px 0;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
}
.loadingDialog .link {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  font-family: monospace;
  font-size: 0.5em;
  text-decoration: none;
  margin: 16px 0 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 4px;
  padding: 8px 16px;
  color: black;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  white-space: nowrap;
  -webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
          box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
.loadingDialog .link[disabled] {
  background: transparent;
  color: rgba(255, 255, 255, 0.5);
  outline: 1px solid rgba(255, 255, 255, 0.25);
  pointer-events: none;
  cursor: default;
}
.loadingDialog .link:not([disabled]):hover {
  background: rgba(255, 255, 255, 0.5);
}
.loadingDialog .link-copy {
  min-width: 50px;
  text-align: center;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
.loadingDialog .qr-code {
  text-align: center;
  display: none;
  margin-bottom: 15px;
}

@media screen and (max-width: 720px) {
  .loadingDialog .qr-code {
    text-align: center;
    display: block;
  }
  .loadingDialog .link-copy {
    min-width: 100%;
    margin-top: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/loadingDialog.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;MAAA,WAAA;UAAA,OAAA;AACJ;AAEE;EACE,2BAAA;EAAA,2BAAA;EAAA,oBAAA;EACA,mBAAA;MAAA,WAAA;UAAA,OAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EAEA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,mBAAA;EAEA,kDAAA;UAAA,0CAAA;EACA,4BAAA;EAAA,oBAAA;AAFJ;AAII;EACE,uBAAA;EACA,+BAAA;EACA,4CAAA;EACA,oBAAA;EAEA,eAAA;AAHN;AAMI;EACE,oCAAA;AAJN;AAQE;EACE,eAAA;EACA,kBAAA;EACA,8BAAA;UAAA,sBAAA;AANJ;AASE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAPJ;;AAWA;EAEI;IACE,kBAAA;IACA,cAAA;EATJ;EAYE;IACE,eAAA;IACA,aAAA;EAVJ;AACF","sourcesContent":[".loadingDialog {\n  width: 350px;\n\n  .alert {\n    font-family: monospace;\n    font-size: 0.75em;\n    background: #cecece;\n    color: #575757;\n    border-radius: 8px;\n    padding: 14px 18px;\n    margin: 10px 0;\n    flex: 1;\n  }\n\n  .link {\n    display: inline-flex;\n    flex: 1;\n    font-family: monospace;\n    font-size: 0.5em;\n    text-decoration: none;\n    margin: 16px 0 16px;\n    background: rgba(255, 255, 255, 0.7);\n    border-radius: 4px;\n    padding: 8px 16px;\n    color: black;\n\n    justify-content: center;\n    align-items: center;\n    white-space: nowrap;\n\n    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n    transition: all 0.3s;\n\n    &[disabled] {\n      background: transparent;\n      color: rgba(255, 255, 255, 0.5);\n      outline: 1px solid rgba(255, 255, 255, 0.25);\n      pointer-events: none;\n\n      cursor: default;\n    }\n\n    &:not([disabled]):hover {\n      background: rgba(255, 255, 255, 0.5);\n    }\n  }\n\n  .link-copy {\n    min-width: 50px;\n    text-align: center;\n    box-sizing: border-box;\n  }\n\n  .qr-code {\n    text-align: center;\n    display: none;\n    margin-bottom: 15px;\n  }\n}\n\n@media screen and (max-width: 720px) {\n  .loadingDialog {\n    .qr-code {\n      text-align: center;\n      display: block;\n    }\n\n    .link-copy {\n      min-width: 100%;\n      margin-top: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
